
<template>
  <div class="pull-height animated" :class="{'zoomOutUp': isLock}">
    <div class="nav">
      <top class="top"></top>
    </div>
    <div class="index">
      <sidebar class="left"></sidebar>
      <div class="right">
        <!--<div class="nav">-->
          <!--<top class="top"></top>-->
        <!--</div>-->
        <div class="main"  ref="ciicMainBox">
          <div class="router" id="main" ref="ciicMain"  >
            <keep-alive>
              <router-view @toTop="scrolltop"  v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
            </keep-alive>
            <router-view @toTop="scrolltop"  v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import top from './top/';
import sidebar from './sidebar/';
export default {
  components: {
    top,
    sidebar,
  },
  name: 'index',
  data() {
    return {
      isRouterAlive: true,
      dicts: {}
    };
  },
  created() {
		document.documentElement.style = '';
    // /*this.getDicts().then((res) => {
    //     this.dicts = res.data.data;
    //     this.$store.commit('SET_DICTS', this.dicts)
    // });*/
  },
  mounted() {
    // 主题 light-theme/白  dark-theme/黑
    if ( typeof(localStorage.Theme) == "undefined" ){
      localStorage.setItem('Theme', "light-theme");
      localStorage.setItem('Color', "#000000");
    }
    document.getElementsByTagName("body")[0].className=localStorage.getItem("Theme");
    this.$store.commit('SET_WORKSPACE_RECT',this.$refs.ciicMain);

  },
  computed: mapGetters(['isLock','menu']),
  props: [],
  provide() {
    return {
      reload: this.reload,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 回到顶部
    scrolltop() {
      this.$refs.ciicMainBox.scrollTop = 0
    }
  },
};
</script>

<style lang="scss" scoped>
.index {
  display: flex;
  position: relative;
  height: calc(100% - 65px);
  background: #fff;
  overflow: hidden;
  .left {
    width: 180px;
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;
    margin-top: 0px;
  }
  .left:before{
    content:"";
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
    z-index: 10;
  }
  .left.is-active:before{
    content:"";
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
  }
  .right {
    /*padding-top: 60px;*/
    position: relative;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    flex: 1;
  }
  .main {
    height: 100%;
    background: #F5F5F5;
    box-sizing: border-box;
    overflow-y: scroll;
    .router {
      padding: 15px;
      padding-bottom: 0px;
      background: #fff;
      min-height: 100%;
      height: auto;
      overflow: hidden;
      border-radius: 5px;
      box-sizing: border-box;
    }
  }
  .nav {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 12;
    box-shadow: 0 0 1px rgba(0,0,0,0.25);
  }
  .top {
    /*margin-bottom: 2px;*/
    height: 60px;
  }
}
</style>
